import { createAction } from '@reduxjs/toolkit';

import type { SvaraDailyMissionsResponse, SvaraMissionClaimGrant } from '../../services/api';

export type MissionClaimTarget = string;

export const MISSIONS_CHEST_TARGET = 'completion';

export const missionsHubRequest = createAction('missions/hub/request');
export const missionsHubSuccess = createAction<SvaraDailyMissionsResponse>('missions/hub/success');
export const missionsHubFailure = createAction<string>('missions/hub/failure');

export const missionClaimRequest = createAction<{ missionId: string; cycleKey: string }>(
	'missions/claim/request',
);
export const missionChestClaimRequest = createAction<{ cycleKey: string }>(
	'missions/chestClaim/request',
);

export const missionClaimSuccess = createAction<{
	target: MissionClaimTarget;
	outcome: 'paid' | 'partial' | 'alreadyClaimed';
	grants: SvaraMissionClaimGrant[];
}>('missions/claim/success');

export const missionClaimFailure = createAction<{ target: MissionClaimTarget; key: string }>(
	'missions/claim/failure',
);

export const missionClaimDismiss = createAction('missions/claim/dismiss');

export const missionsModalOpened = createAction('missions/modal/opened');
export const missionsModalClosed = createAction('missions/modal/closed');
